import { create } from "zustand";

type SidebarStore = {
  isOpen: boolean;
  toggleSidebar: () => void;
  setSidebarState: (isOpen: boolean) => void;
};

// Check if initial screen width is >= 1200px to determine default sidebar state
const getInitialSidebarState = (): boolean => {
  if (typeof window === "undefined") return true; // SSR fallback
  return window.innerWidth >= 1200;
};

const useSidebarStore = create<SidebarStore>((set) => ({
  isOpen: getInitialSidebarState(),
  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
  setSidebarState: (isOpen: boolean) => set({ isOpen }),
}));

export default useSidebarStore;
